import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerInitBankDetailsApiCallSuccess } from 'redux/actions';
import { TRIGGER_INIT_BANK_DETAILS_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerInitBankDetailsApiCall(actions) {
	const { data, callback } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.INIT_BANK_DETAILs,
		data,
		method: 'POST',
		options: {
			dontRemoveLoader: true,
		},
		loaderDetails: {
			first_message: 'verifying your',
			start_index: 0,
			range: 9,
			second_message: 'details',
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		callback && callback(apiData);
		yield put(triggerInitBankDetailsApiCallSuccess(apiData));
	}
}

export default function* triggerInitBankDetailsApiCallSaga() {
	yield takeEvery(TRIGGER_INIT_BANK_DETAILS_API, triggerInitBankDetailsApiCall);
}
